var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLogoFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 56,
  viewBox: "0 0 72 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M71.3522 0H0V55.0342H71.3522V0Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.585 48.8717V6.15625L6.15691 6.15625L6.15691 48.8717H32.585Z",
  fill: "#FFCB05"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M65.2004 48.8717V6.15625L38.7724 6.15625V48.8717H65.2004Z",
  fill: "#001246"
})));
export default SvgIconLogoFlag;